import { render, staticRenderFns } from "./DealsDescriptions.vue?vue&type=template&id=ae5005a0&"
import script from "./DealsDescriptions.vue?vue&type=script&lang=js&"
export * from "./DealsDescriptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports